import { render, staticRenderFns } from "./TemplateSaveButton.vue?vue&type=template&id=11893914&"
import script from "./TemplateSaveButton.vue?vue&type=script&lang=js&"
export * from "./TemplateSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports